import { Option } from "../../../../store/types";

export * from "./additional-purchase";
export * from "./new-purchase";
export * from "./sip";
export const CREATE_MANADATE_OPTIONS = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

export type GetOption = ({
  Pay_Mode,
  Pay_Mode_Val,
}: {
  Pay_Mode: string;
  Pay_Mode_Val: string;
}) => Option;

export const getOptions: GetOption = function ({ Pay_Mode, Pay_Mode_Val }) {
  return {
    label: Pay_Mode,
    value: Pay_Mode_Val,
  };
};

export const getValidPaymodes = function ({ label }: Option) {
  return label === "AOTM" || label === "KOTM";
};
export const pioReferenceRegex = /^[sS]\d{8}$/;
